import urlData from './legacy-url-data';
import * as R from 'ramda';
import { getValue, parseHash } from './url-utils';
const NOT_FIXED_STRING_FIELDS = ['keyWord', 'comissionId'];
const keys = urlData.keys;
const values = urlData.values;

const urlToStateSelectedTags = R.pipe(
	R.split('&'),
	R.map(
		R.pipe(
			R.split('|'),
			R.applySpec({
				value: R.pipe(R.nth(0)),
				type: R.nth(1)
			})
		)
	)
);

const urlToStateRange = (baseKey, value, state) => {
	const STRING_VALUES_PARAMS = ['floorsInBuilding'];
	const isStringValue = R.includes(baseKey, STRING_VALUES_PARAMS);
	const newState = R.clone(state);
	const [min, max] = R.split('~', value);
	const minValue = isStringValue ? getValue(values)(baseKey, min) : parseInt(min, 10);
	const maxValue = isStringValue ? getValue(values)(baseKey, max) : parseInt(max, 10);
	newState[`${baseKey}Minimum`] = R.defaultTo(null, minValue);
	newState[`${baseKey}Maximum`] = R.defaultTo(null, maxValue);
	return newState;
};

const urlToStateBoolean = (key, obj) => {
	return R.assoc(key, true, obj);
};
const urlToStateArray = (key, value) => {
	const getTranslatedValue = translateKey => item => values[translateKey][item];
	debugger;
	return R.pipe(R.split('&'), R.map(getTranslatedValue(key)), R.reject(R.isNil))(value);
};
export default {
	createStateFromUrl() {
		const SIMPLE_SEARCH_KEYS = ['price', 'saleType', 'propertyType', 'area', 'selectedTags', 'advancedSearchVisible', 'order'];
		const FIXED_VALUE_PROPERTIES = ['saleType', 'propertyType', 'order'];
		const ARRAY_TYPES = [
			'conditionOfProperty',
			'heating',
			'buildingStructure',
			'comfortLevel',
			'staircaseType',
			'livingRoomOrientation',
			'view',
			'parkingOption',
			'innerHeight'
		];

		const urlObj = parseHash(window.location.hash);
		const stateObj = R.reduce(
			(acc, item) => {
				const isSimple = R.includes(keys[item], SIMPLE_SEARCH_KEYS);
				let advancedOrSimpleObj = isSimple ? acc.simple : acc.advanced;
				if (keys[item]) {
					if (R.includes(keys[item], FIXED_VALUE_PROPERTIES)) {
						advancedOrSimpleObj = R.assoc(keys[item], values[keys[item]][urlObj[item]], advancedOrSimpleObj);
					} else if (R.includes(keys[item], NOT_FIXED_STRING_FIELDS)) {
						advancedOrSimpleObj = R.assoc(keys[item], urlObj[item], advancedOrSimpleObj);
					} else if (R.includes(keys[item], ARRAY_TYPES)) {
						advancedOrSimpleObj = R.assoc(keys[item], urlToStateArray(keys[item], urlObj[item]), advancedOrSimpleObj);
					} else if (R.includes('~', urlObj[item])) {
						advancedOrSimpleObj = urlToStateRange(keys[item], urlObj[item], advancedOrSimpleObj);
					} else if (R.equals('selectedTags', keys[item])) {
						advancedOrSimpleObj = R.assoc(keys[item], urlToStateSelectedTags(urlObj[item]), advancedOrSimpleObj);
					} else if (R.equals('true', urlObj[item])) {
						advancedOrSimpleObj = urlToStateBoolean(keys[item], advancedOrSimpleObj);
					}

					if (isSimple) {
						acc.simple = advancedOrSimpleObj;
					} else {
						acc.advanced = advancedOrSimpleObj;
					}
				}
				return acc;
			},
			{ advanced: {}, simple: {} },
			R.keys(urlObj)
		);
		debugger;
		return stateObj;
	}
};
